import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { GenericDialogComponent } from '../_components/common/generic-dialog/generic-dialog.component';


export class GenericModalUtil {
	public static openConfirmCloseDialogWithRef(
		dialogRef: MatDialogRef<unknown>,
		translateService: TranslateService,
		dialog: MatDialog,
		questionMessage?: string,
	): void {
		const confirmDialogRef = GenericModalUtil.createConfirmDialog(translateService, dialog, questionMessage);

		confirmDialogRef.afterClosed().subscribe((result) => {
			if (result) {
				dialogRef.close();
			}
		});
	}

	public static openConfirmCloseDialog(
		translateService: TranslateService,
		dialog: MatDialog,
	): MatDialogRef<GenericDialogComponent, any> {
		const confirmDialogRef = GenericModalUtil.createConfirmDialog(translateService, dialog);
		return confirmDialogRef;
	}

	public static openConfirmActionDialog(
		translateService: TranslateService,
		dialog: MatDialog,
		confirmMessage: string,
	): MatDialogRef<GenericDialogComponent, any> {
		const confirmDialogRef = GenericModalUtil.createConfirmDialog(translateService, dialog, confirmMessage);
		return confirmDialogRef;
	}

	public static createConfirmDialog(
		translateService: TranslateService,
		dialog: MatDialog,
		confirmMessage?: string,
	): MatDialogRef<GenericDialogComponent, any> {
		const confirmDialogRef = dialog.open(GenericDialogComponent, {
			width: '400px',
			autoFocus: false,
			hasBackdrop: true,
			disableClose: true,
			restoreFocus: false,
		});

		confirmDialogRef.componentInstance.dialogData = {
			title: translateService.instant('dialog.warning'),
			message: translateService.instant(confirmMessage ?? 'dialog.closeQuestion'),
			confirmButton: translateService.instant('dialog.button.yes'),
			cancelButton: translateService.instant('dialog.button.cancel'),
		};

		return confirmDialogRef;
	}
}
